/**
 * ******************
 * USER SIDEBAR JS
 * ******************
 */

/**
 * Variables
 *
 * @type {string}
 */
var userButton = document.querySelector('[data-js="user-button"]');
var userSidebar = document.querySelector('[data-js="user-sidebar"]');
var userSidebarClassShow = 'user-sidebar_is_show';
var userSidebarIsShow = false;

if(userSidebar.classList.contains(userSidebarClassShow)) {
    userSidebarIsShow = true;
    document.addEventListener('click', clickInsideUserSidebar, true);
}

/**
 * Function toggleDropdownSearch
 *
 * Controls the visibility of the dropdown
 */
function toggleUserSidebar() {
    if(userSidebarIsShow) {
        userSidebarIsShow = false;
        userSidebar.classList.remove(userSidebarClassShow);
        document.removeEventListener('click', clickInsideUserSidebar, true);
    } else {
        userSidebarIsShow = true;
        userSidebar.classList.add(userSidebarClassShow);
        document.addEventListener('click', clickInsideUserSidebar, true);
    }
}

/**
 * Function clickInsideSearchDropdown
 *
 * Control the click inside the dropdown
 */
function clickInsideUserSidebar() {
    var isClickInsideUserButton = userButton.contains(event.target);
    var isClickInsideUserSidebar = userSidebar.contains(event.target);

    if (!isClickInsideUserButton && !isClickInsideUserSidebar) {
        toggleUserSidebar();
    }
}